// Sample reviews data structure
export const reviews = {
  // Reviews are stored by product ID
  // Product 1 - 100 Python Automation Scripts (₹549)
  1: [
    {
      id: 1,
      userName: "Nikhil Chandail",
      rating: 5,
      comment: "Very useful Tools  Please Make a video for prompt engineering for hackers also ",
      date: "2025-10-15"
    },
    {
      id: 2,
      userName: "Arpit Aggarwal",
      rating: 5,
      comment: "❤️❤️❤️❤️❤️",
      date: "2025-10-10"
    },
    {
      id: 3,
      userName: "Ayush Kumar",
      rating: 4,
      comment: "college projects are good. Very useful for me.",
      date: "2025-11-10"
    }
    ,
    {
      id: 4,
      userName: "Parush ",
      rating: 0,
      comment: "Any Free Resources available ?",
      date: "2025-08-18"
    },
    {
      id: 5,
      userName: "Meera Shah",
      rating: 5,
      comment: "Highly recommend!",
      date: "2025-12-05"
    },
    {
      id: 6,
      userName: "Aman gupta",
      rating: 5,
      comment: "Thanks"
    },
    {
      id: 7,
      userName: "Daksh ",
      rating: 5,
      comment: "Girlfriend ka phone hack karne ke liye best hai",
    },
    {
      id: 8,
      userName: "Hacker",
      rating: 4,
      comment: "Nice"
    },
    {
      id: 9,
      userName: "Mr.x",
      rating: 5,
      comment: "Very good content. large library."
    }
  ],
  // Product 2 - 700+ Python Automation Tools (₹578)
  2: [
    {
      id: 1,
      userName: "Mike Johnson",
      rating: 5,
      comment: "Comprehensive toolkit, exactly what I needed!",
      date: "2024-03-13"
    },
    {
      id: 2,
      userName: "Emily Rodriguez",
      rating: 5,
      comment: "Amazing collection of automation tools. The CI/CD integration examples are particularly helpful for my DevOps workflow.",
      date: "2024-12-08"
    }
  ],
  // Product 3 - Advanced Cybersecurity SOC concepts (₹648) - Most expensive
  3: [
    {
      id: 1,
      userName: "Alex Thompson",
      rating: 5,
      comment: "Outstanding SOC training material! The hands-on labs and real-world case studies made complex concepts easy to understand. Worth every rupee.",
      date: "2024-12-12"
    }
  ],
  // Product 4 - AI & Machine Learning Handbooks (₹628)
  4: [
    {
      id: 1,
      userName: "Dr. Priya Sharma",
      rating: 5,
      comment: "Comprehensive ML handbooks with practical examples. The Jupyter notebooks are well-structured and the TensorFlow examples are excellent.",
      date: "2024-12-14"
    },
    {
      id: 2,
      userName: "David Kim",
      rating: 4,
      comment: "Great resource for ML practitioners. The code examples are clean and the explanations are thorough. Perfect for intermediate to advanced learners.",
      date: "2024-12-09"
    }
  ],
  // Product 5 - Analytics Dashboard Template (₹558)
  5: [
    {
      id: 1,
      userName: "Lisa Wang",
      rating: 5,
      comment: "Beautiful dashboard template! The React components are modern and the D3.js visualizations are stunning. Easy to customize for our needs.",
      date: "2024-12-11"
    },
    {
      id: 2,
      userName: "Carlos Mendez",
      rating: 4,
      comment: "Professional dashboard with great documentation. The responsive design works perfectly across all devices. Highly recommended!",
      date: "2024-12-07"
    }
  ],
  // Product 6 - Budget Plan Templates (₹538)
  6: [
    {
      id: 1,
      userName: "Jennifer Lee",
      rating: 5,
      comment: "Excellent financial planning templates! The automated calculations and forecasting features saved me so much time. Perfect for both personal and business use.",
      date: "2024-12-13"
    },
    {
      id: 2,
      userName: "Michael Brown",
      rating: 4,
      comment: "Well-designed templates with clear instructions. The Excel formulas work perfectly and the customization options are extensive.",
      date: "2024-12-06"
    }
  ],
  // Product 7 - Business Analytics Dashboard (₹568)
  7: [
    {
      id: 1,
      userName: "Amanda Foster",
      rating: 5,
      comment: "Powerful business analytics solution! The KPI tracking and real-time data integration features are exactly what our company needed.",
      date: "2024-12-10"
    },
    {
      id: 2,
      userName: "Robert Taylor",
      rating: 4,
      comment: "Great dashboard for business intelligence. The export options and role-based access control make it perfect for enterprise use.",
      date: "2024-12-05"
    }
  ],
  // Product 8 - Business Articles of Incorporation templates (₹548)
  8: [
    {
      id: 1,
      userName: "Maria Garcia",
      rating: 5,
      comment: "Professional legal templates that saved me thousands in attorney fees. The state-specific forms are comprehensive and easy to fill out.",
      date: "2024-12-12"
    },
    {
      id: 2,
      userName: "James Wilson",
      rating: 4,
      comment: "Excellent incorporation templates with clear instructions. The attorney review gives me confidence in the legal accuracy.",
      date: "2024-12-08"
    }
  ],
  // Product 9 - Business Client Onboarding Templates (₹538)
  9: [
    {
      id: 1,
      userName: "Sophie Anderson",
      rating: 5,
      comment: "Game-changer for our client onboarding process! The workflow templates and automation guides streamlined our entire operation.",
      date: "2024-12-11"
    },
    {
      id: 2,
      userName: "Kevin Zhang",
      rating: 4,
      comment: "Comprehensive onboarding toolkit. The CRM integration guides and GDPR compliance features are particularly valuable.",
      date: "2024-12-07"
    }
  ],
  // Product 10 - Business Model Templates (₹548)
  10: [
    {
      id: 1,
      userName: "Rachel Green",
      rating: 5,
      comment: "Perfect for startup planning! The business model canvas and value proposition tools helped me refine my business strategy.",
      date: "2024-12-09"
    },
    {
      id: 2,
      userName: "Tom Anderson",
      rating: 4,
      comment: "Well-structured templates with great examples. The financial modeling sheets and case studies provide excellent guidance.",
      date: "2024-12-06"
    }
  ],
  // Product 11 - Business Plan Templates (₹558)
  11: [
    {
      id: 1,
      userName: "Nina Patel",
      rating: 5,
      comment: "Comprehensive business plan templates with excellent financial models. The 5-year projections helped me secure funding for my startup.",
      date: "2024-12-14"
    },
    {
      id: 2,
      userName: "Daniel Cooper",
      rating: 4,
      comment: "Professional templates with clear structure. The industry examples and market analysis frameworks are very helpful for planning.",
      date: "2024-12-11"
    }
  ],
  // Product 12 - Business Strategy Handbooks (₹578)
  12: [
    {
      id: 1,
      userName: "Victoria Stone",
      rating: 5,
      comment: "MBA-level content at an incredible price! The strategy frameworks and case studies are exactly what I needed for my consulting practice.",
      date: "2024-12-13"
    },
    {
      id: 2,
      userName: "Marcus Johnson",
      rating: 4,
      comment: "Excellent resource for strategic planning. The 30+ strategy tools and real-world examples make complex concepts accessible.",
      date: "2024-12-09"
    }
  ],
  // Product 13 - Company Deck Templates (₹548)
  13: [
    {
      id: 1,
      userName: "Elena Rodriguez",
      rating: 5,
      comment: "Stunning presentation templates! The 100+ slides and professional animations helped me create an impressive company pitch deck.",
      date: "2024-12-12"
    },
    {
      id: 2,
      userName: "Andrew Kim",
      rating: 4,
      comment: "High-quality templates with great customization options. The 4K resolution and multiple format support are perfect for presentations.",
      date: "2024-12-08"
    }
  ],
  // Product 14 - Company Profile Templates (₹538)
  14: [
    {
      id: 1,
      userName: "Isabella Chen",
      rating: 5,
      comment: "Professional company profile templates that made our business look polished and credible. The print-ready formats are perfect for marketing materials.",
      date: "2024-12-10"
    },
    {
      id: 2,
      userName: "Ryan Murphy",
      rating: 4,
      comment: "Well-designed templates with comprehensive sections. The brand guidelines integration makes customization easy and consistent.",
      date: "2024-12-07"
    }
  ],
  // Product 15 - Contracts & Agreements Templates (₹578)
  15: [
    {
      id: 1,
      userName: "Grace Williams",
      rating: 5,
      comment: "Essential legal templates that saved me thousands in legal fees. The attorney review and state-specific compliance give me confidence.",
      date: "2024-12-11"
    },
    {
      id: 2,
      userName: "Lucas Brown",
      rating: 4,
      comment: "Comprehensive contract templates with clear instructions. The customizable terms and usage guidelines make legal documentation accessible.",
      date: "2024-12-06"
    }
  ],
  // Product 16 - cyber-security-books (₹698) - Most expensive
  16: [
    {
      id: 1,
      userName: "Dr. Michael Torres",
      rating: 5,
      comment: "Outstanding cybersecurity resource collection! The 25+ comprehensive guides cover everything from network security to ethical hacking. The 5000+ pages of content are worth every rupee.",
      date: "2024-12-15"
    }
  ],
  // Product 17 - Hacker's Library Bundle (₹548)
  17: [
    {
      id: 1,
      userName: "Adhaar Koul ",
      rating: 5,
      comment: "I was the first customer. Very helpful resources.",
      date: "2025-11-04"
    },
    {
      id: 2,
      userName: "Ronit",
      rating: 5,
      comment: "Bhai bhot sahi chez hai. Maine apne dost ka PC faad dia isse 😂",
      date: "2025-11-04"
    },
    {
      id: 3,
      userName: "Ankit",
      rating: 5,
      comment: "Nice. Thanks.",
      date: "2025-11-05"
    }
  ],
  // Product 18 - Cybersecurity Shortlisted Resumes (₹528)
  18: [
    {
      id: 1,
      userName: "Jessica Park",
      rating: 5,
      comment: "Perfect resume templates for cybersecurity roles! The ATS optimization helped me get multiple interview calls. The industry-specific content is spot-on.",
      date: "2024-12-13"
    },
    {
      id: 2,
      userName: "Brandon Lee",
      rating: 4,
      comment: "Professional templates with great customization options. The sample content and best practices guide made resume writing much easier.",
      date: "2024-12-10"
    }
  ],
  // Product 19 - cybersecurity-free-tutorials (₹578)
  19: [
    {
      id: 1,
      userName: "Chris Anderson",
      rating: 5,
      comment: "Comprehensive cybersecurity tutorials with hands-on labs! The 50+ tutorials and 100+ hours of content are perfect for skill development.",
      date: "2024-12-12"
    },
    {
      id: 2,
      userName: "Samantha Davis",
      rating: 4,
      comment: "Excellent learning resource with practical examples. The video content and interactive labs make complex security concepts easy to understand.",
      date: "2024-12-08"
    }
  ],
  // Product 20 - Datasets (₹588)
  20: [
    {
      id: 1,
      userName: "Dr. Ahmed Hassan",
      rating: 5,
      comment: "High-quality datasets perfect for data science projects! The 100+ curated datasets with 10GB+ of data are well-documented and ready to use.",
      date: "2024-12-14"
    },
    {
      id: 2,
      userName: "Michelle Taylor",
      rating: 4,
      comment: "Excellent collection of clean datasets. The multiple formats and comprehensive documentation make data analysis projects much easier.",
      date: "2024-12-09"
    }
  ],
  // Product 21 - DevOps Automation Scripts (₹618)
  21: [
    {
      id: 1,
      userName: "Oliver Thompson",
      rating: 5,
      comment: "Game-changing DevOps automation scripts! The 200+ scripts covering CI/CD, infrastructure as code, and monitoring saved our team countless hours.",
      date: "2024-12-13"
    },
    {
      id: 2,
      userName: "Zoe Martinez",
      rating: 4,
      comment: "Comprehensive automation toolkit with excellent documentation. The cross-platform support and testing frameworks make deployment much smoother.",
      date: "2024-12-10"
    }
  ],
  // Product 22 - Employee Handbook (₹548)
  22: [
    {
      id: 1,
      userName: "Hannah Wilson",
      rating: 5,
      comment: "Professional employee handbook template that covers all essential policies. The legal compliance and customization options made HR documentation a breeze.",
      date: "2024-12-12"
    },
    {
      id: 2,
      userName: "Tyler Johnson",
      rating: 4,
      comment: "Well-structured templates with comprehensive policy sections. The annual legal updates and HR consultation support provide great value.",
      date: "2024-12-08"
    }
  ],
  // Product 23 - Employment Agreement Templates (₹578)
  23: [
    {
      id: 1,
      userName: "Sophia Davis",
      rating: 5,
      comment: "Essential employment agreement templates with attorney review! The state-specific compliance and customizable terms saved us thousands in legal fees.",
      date: "2024-12-11"
    },
    {
      id: 2,
      userName: "Ethan Brown",
      rating: 4,
      comment: "Professional templates covering all employment types. The clear instructions and sample clauses make legal documentation accessible to non-lawyers.",
      date: "2024-12-07"
    }
  ],
  // Product 24 - ESP8266 Scripts and Exploits (₹568)
  24: [
    {
      id: 1,
      userName: "Liam Chen",
      rating: 5,
      comment: "Excellent ESP8266 development resource! The 50+ scripts for WiFi, security, and automation are well-documented and ready to use.",
      date: "2024-12-14"
    },
    {
      id: 2,
      userName: "Ava Rodriguez",
      rating: 4,
      comment: "Great collection of IoT scripts with practical examples. The Arduino IDE and PlatformIO compatibility make integration seamless.",
      date: "2024-12-09"
    }
  ],
  // Product 25 - Expense Report Templates (₹528)
  25: [
    {
      id: 1,
      userName: "Noah Kim",
      rating: 5,
      comment: "Perfect expense tracking solution! The 20+ templates with automated calculations and tax-compliant formats streamlined our expense management.",
      date: "2024-12-13"
    },
    {
      id: 2,
      userName: "Emma Garcia",
      rating: 4,
      comment: "Well-designed templates with comprehensive categories. The export options and customization features make expense reporting efficient and accurate.",
      date: "2024-12-10"
    }
  ],
  // Product 26 - Independent Contractor Agreement Templates (₹548)
  26: [
    {
      id: 1,
      userName: "William Lee",
      rating: 5,
      comment: "Comprehensive contractor agreement templates! The federal compliance and state-specific requirements give me confidence in legal accuracy.",
      date: "2024-12-12"
    },
    {
      id: 2,
      userName: "Mia Patel",
      rating: 4,
      comment: "Professional templates with clear customization options. The attorney review and annual updates ensure legal compliance and peace of mind.",
      date: "2024-12-08"
    }
  ],
  // Product 27 - Investment Proposal Templates (₹568)
  27: [
    {
      id: 1,
      userName: "James Wilson",
      rating: 5,
      comment: "Outstanding investment proposal templates! The financial models with ROI, NPV, and IRR calculations helped me secure funding for my startup.",
      date: "2024-12-11"
    },
    {
      id: 2,
      userName: "Charlotte Taylor",
      rating: 4,
      comment: "Professional templates with industry-specific examples. The SEC compliance and financial consultation support provide excellent value.",
      date: "2024-12-07"
    }
  ],
  // Product 28 - Linux-Tools (₹588)
  28: [
    {
      id: 1,
      userName: "Benjamin Anderson",
      rating: 5,
      comment: "Essential Linux administration toolkit! The 100+ utilities for system, network, security, and monitoring are well-tested and documented.",
      date: "2024-12-14"
    },
    {
      id: 2,
      userName: "Amelia White",
      rating: 4,
      comment: "Comprehensive collection of Linux tools with cross-platform support. The monthly updates and technical support make system administration much easier.",
      date: "2024-12-09"
    }
  ],
  // Product 29 - Marketing Plan Templates (₹558)
  29: [
    {
      id: 1,
      userName: "Lucas Martinez",
      rating: 5,
      comment: "Strategic marketing templates that transformed our campaigns! The 20+ formats with B2B, B2C, and SaaS examples provided excellent guidance.",
      date: "2024-12-13"
    },
    {
      id: 2,
      userName: "Harper Thompson",
      rating: 4,
      comment: "Well-structured templates with comprehensive frameworks. The campaign planning tools and best practices guide made marketing strategy accessible.",
      date: "2024-12-10"
    }
  ],
  // Product 30 - Non-Disclosure Agreement Templates (₹538)
  30: [
    {
      id: 1,
      userName: "Henry Davis",
      rating: 5,
      comment: "Essential NDA templates for business protection! The mutual, unilateral, and employee versions with attorney review provide comprehensive coverage.",
      date: "2024-12-12"
    },
    {
      id: 2,
      userName: "Evelyn Brown",
      rating: 4,
      comment: "Professional templates with clear customization options. The federal and state law compliance gives confidence in legal protection.",
      date: "2024-12-08"
    }
  ],
  // Product 31 - Offer Letter Templates (₹548)
  31: [
    {
      id: 1,
      userName: "Alexander Kim",
      rating: 5,
      comment: "Professional offer letter templates that streamline our hiring process! The 15+ formats for different positions and industries are perfect.",
      date: "2024-12-13"
    },
    {
      id: 2,
      userName: "Grace Wilson",
      rating: 4,
      comment: "Well-designed templates with comprehensive customization options. The legal compliance and HR consultation support provide excellent value.",
      date: "2024-12-10"
    }
  ],
  // Product 32 - OSCP Study Material (₹698) - Most expensive
  32: [
    {
      id: 1,
      userName: "Dr. Sarah Mitchell",
      rating: 5,
      comment: "Exceptional OSCP preparation material! The comprehensive curriculum with hands-on labs and practice tests made me pass the exam on my first attempt. Worth every rupee!",
      date: "2024-12-15"
    }
  ],
  // Product 33 - Presentation templates (₹548)
  33: [
    {
      id: 1,
      userName: "Nathan Rodriguez",
      rating: 5,
      comment: "Stunning presentation templates for all occasions! The 50+ designs with professional animations and 4K resolution made our presentations stand out.",
      date: "2024-12-12"
    },
    {
      id: 2,
      userName: "Lily Chen",
      rating: 4,
      comment: "High-quality templates with great customization options. The multiple format support and editable infographics make presentations professional and engaging.",
      date: "2024-12-09"
    }
  ],
  // Product 34 - Printable Study Planners (₹518)
  34: [
    {
      id: 1,
      userName: "Caleb Thompson",
      rating: 5,
      comment: "Perfect study organization solution! The 25+ planner designs with daily, weekly, and semester formats helped me stay organized and productive.",
      date: "2024-12-14"
    },
    {
      id: 2,
      userName: "Natalie Davis",
      rating: 4,
      comment: "Well-structured planners with excellent customization options. The print-ready formats and mobile-friendly versions make studying more efficient.",
      date: "2024-12-11"
    }
  ],
  // Product 35 - Privacy Policy Templates (₹538)
  35: [
    {
      id: 1,
      userName: "Isaac Martinez",
      rating: 5,
      comment: "Essential privacy policy templates with GDPR compliance! The website, app, and e-commerce versions saved us thousands in legal fees.",
      date: "2024-12-13"
    },
    {
      id: 2,
      userName: "Zoe Anderson",
      rating: 4,
      comment: "Professional templates with comprehensive legal coverage. The international compliance and annual updates ensure ongoing legal protection.",
      date: "2024-12-10"
    }
  ],
  // Product 36 - Python API Testing Tools (₹578)
  36: [
    {
      id: 1,
      userName: "Gabriel White",
      rating: 5,
      comment: "Comprehensive API testing toolkit! The 30+ tools supporting REST, GraphQL, and SOAP APIs with pytest integration transformed our testing workflow.",
      date: "2024-12-12"
    },
    {
      id: 2,
      userName: "Chloe Brown",
      rating: 4,
      comment: "Excellent collection of testing tools with practical examples. The Python 3.7+ compatibility and comprehensive documentation make API testing efficient.",
      date: "2024-12-08"
    }
  ],
  // Product 37 - Python Resume Parser Tool (₹558)
  37: [
    {
      id: 1,
      userName: "Mason Garcia",
      rating: 5,
      comment: "Advanced resume parsing solution! The support for PDF, Word, TXT, and HTML formats with NLTK integration streamlined our recruitment process.",
      date: "2024-12-11"
    },
    {
      id: 2,
      userName: "Aria Patel",
      rating: 4,
      comment: "Powerful parsing tool with excellent data extraction capabilities. The cross-platform compatibility and comprehensive documentation make it easy to use.",
      date: "2024-12-07"
    }
  ],
  // Product 38 - Python-for-Security-and-Networking (₹628)
  38: [
    {
      id: 1,
      userName: "Logan Kim",
      rating: 5,
      comment: "Essential Python security toolkit! The 40+ tools for network scanning, vulnerability assessment, and forensics are well-documented and tested.",
      date: "2024-12-14"
    },
    {
      id: 2,
      userName: "Scarlett Wilson",
      rating: 4,
      comment: "Comprehensive security tools with practical applications. The Scapy and Cryptography libraries integration make network security testing efficient.",
      date: "2024-12-09"
    }
  ],
  // Product 39 - Royality Free Music (₹568)
  39: [
    {
      id: 1,
      userName: "Jackson Lee",
      rating: 5,
      comment: "High-quality royalty-free music collection! The 100+ tracks across multiple genres with commercial licensing saved us thousands in music costs.",
      date: "2024-12-13"
    },
    {
      id: 2,
      userName: "Penelope Taylor",
      rating: 4,
      comment: "Excellent music library with professional quality. The 320kbps MP3 and 44.1kHz WAV formats provide flexibility for different projects.",
      date: "2024-12-10"
    }
  ],
  // Product 40 - Sales Proposal Template (₹548)
  40: [
    {
      id: 1,
      userName: "Sebastian Rodriguez",
      rating: 5,
      comment: "Professional sales proposal templates that close deals! The 20+ formats with B2B, B2C, and SaaS examples helped increase our conversion rate.",
      date: "2024-12-12"
    },
    {
      id: 2,
      userName: "Violet Chen",
      rating: 4,
      comment: "Well-structured templates with comprehensive customization options. The ROI calculators and sales methodology guides provide excellent support.",
      date: "2024-12-08"
    }
  ],
  // Product 41 - Security Blue Team Study Material (₹648) - Most expensive
  41: [
    {
      id: 1,
      userName: "Dr. Kevin Park",
      rating: 5,
      comment: "Outstanding Blue Team training material! The comprehensive curriculum with hands-on labs and real-world case studies prepared me perfectly for the certification exam. Exceptional value!",
      date: "2024-12-15"
    }
  ],
  // Product 42 - SEO Audit Checklist Templates (₹548)
  42: [
    {
      id: 1,
      userName: "Dylan Martinez",
      rating: 5,
      comment: "Comprehensive SEO audit solution! The 15+ templates with automated checklists and professional reporting helped improve our website rankings significantly.",
      date: "2024-12-13"
    },
    {
      id: 2,
      userName: "Hazel Thompson",
      rating: 4,
      comment: "Well-structured audit templates with industry best practices. The customization options and SEO consultation support provide excellent value for digital marketing.",
      date: "2024-12-10"
    }
  ],
  // Product 43 - Social Media Strategy Documents (₹558)
  43: [
    {
      id: 1,
      userName: "Carter Wilson",
      rating: 5,
      comment: "Strategic social media templates that transformed our campaigns! The 25+ templates with platform-specific strategies and content calendars boosted our engagement.",
      date: "2024-12-12"
    },
    {
      id: 2,
      userName: "Stella Davis",
      rating: 4,
      comment: "Excellent strategy frameworks with comprehensive customization options. The performance tracking tools and best practices guide made social media management efficient.",
      date: "2024-12-09"
    }
  ],
  // Product 44 - Software resumes Templates (₹528)
  44: [
    {
      id: 1,
      userName: "Wyatt Brown",
      rating: 5,
      comment: "Perfect resume templates for software developers! The 20+ ATS-optimized designs with industry-specific content helped me land multiple interviews.",
      date: "2024-12-14"
    },
    {
      id: 2,
      userName: "Luna Garcia",
      rating: 4,
      comment: "Professional templates with great customization options. The sample content and best practices guide made resume writing much easier for tech roles.",
      date: "2024-12-11"
    }
  ],
  // Product 45 - Steganography (₹588)
  45: [
    {
      id: 1,
      userName: "Eli Anderson",
      rating: 5,
      comment: "Advanced steganography toolkit! The 15+ tools supporting image, audio, video, and text steganography with comprehensive documentation are perfect for security research.",
      date: "2024-12-13"
    },
    {
      id: 2,
      userName: "Nova Patel",
      rating: 4,
      comment: "Excellent collection of steganography tools with practical examples. The cross-platform compatibility and real-world projects make learning engaging.",
      date: "2024-12-10"
    }
  ],
  // Product 46 - Terms & Conditions Templates (₹538)
  46: [
    {
      id: 1,
      userName: "Owen Kim",
      rating: 5,
      comment: "Essential legal templates for website protection! The website, app, and e-commerce versions with international compliance saved us thousands in legal fees.",
      date: "2024-12-12"
    },
    {
      id: 2,
      userName: "Iris Chen",
      rating: 4,
      comment: "Professional templates with comprehensive legal coverage. The customization options and annual updates ensure ongoing legal protection for our business.",
      date: "2024-12-08"
    }
  ],
  // Product 47 - Website Elements (₹568)
  47: [
    {
      id: 1,
      userName: "Miles Rodriguez",
      rating: 5,
      comment: "Modern UI component library! The 200+ elements with HTML, CSS, JavaScript, and React support transformed our web development workflow.",
      date: "2024-12-11"
    },
    {
      id: 2,
      userName: "Ruby White",
      rating: 4,
      comment: "Excellent collection of website elements with great documentation. The modern design and browser compatibility make web development efficient and professional.",
      date: "2024-12-07"
    }
  ],
  // Product 48 - Website Templates (₹588)
  48: [
    {
      id: 1,
      userName: "Jaxon Taylor",
      rating: 5,
      comment: "Professional website templates for all industries! The 50+ responsive designs with Bootstrap integration helped us launch multiple client projects quickly.",
      date: "2024-12-14"
    },
    {
      id: 2,
      userName: "Sage Wilson",
      rating: 4,
      comment: "High-quality templates with comprehensive customization options. The mobile-first design and modern browser compatibility make website development efficient.",
      date: "2024-12-09"
    }
  ],
  // Product 49 - Windows Hacking Tools (₹628)
  49: [
    {
      id: 1,
      userName: "Kai Martinez",
      rating: 5,
      comment: "Comprehensive Windows security toolkit! The 60+ tools for exploitation, privilege escalation, and persistence are well-documented and tested for educational use.",
      date: "2024-12-13"
    },
    {
      id: 2,
      userName: "Willow Brown",
      rating: 4,
      comment: "Excellent collection of security tools with practical applications. The cross-platform compatibility and comprehensive documentation make security testing efficient.",
      date: "2024-12-10"
    }
  ],
  // Product 50 - Windows exploits (₹648) - Most expensive
  50: [
    {
      id: 1,
      userName: "Dr. Phoenix Lee",
      rating: 5,
      comment: "Advanced Windows security research toolkit! The 80+ exploits covering buffer overflow, ROP, and kernel exploits with comprehensive documentation are perfect for cybersecurity education and research.",
      date: "2024-12-15"
    }
  ]
};

// Function to get reviews for a product
export const getProductReviews = (productId) => {
  return reviews[productId] || [];
};

// Function to add a new review
export const addReview = (productId, review) => {
  if (!reviews[productId]) {
    reviews[productId] = [];
  }
  
  const newReview = {
    ...review,
    id: reviews[productId].length + 1,
    date: new Date().toISOString().split('T')[0]
  };
  
  reviews[productId].unshift(newReview); // Add to beginning of array
  return newReview;
};

// Function to calculate average rating
export const getAverageRating = (productId) => {
  const productReviews = reviews[productId] || [];
  if (productReviews.length === 0) return 0;
  
  const sum = productReviews.reduce((acc, review) => acc + review.rating, 0);
  return (sum / productReviews.length).toFixed(1);
}; 